module.exports = __webpack_public_path__ + "img/4_001.dce88502.webp";